import * as React from 'react';
import { styled, Typography } from '@mui/material';
import Column from '../../components/Column';
import Row from '../../components/Row';

interface Props {
  title?: string;
  titleSize?: string;
  aside?: React.ReactNode;
  marginTop?: string;
  children?: React.JSX.Element | React.JSX.Element[];
  sx?: React.CSSProperties;
}

const DashboardPageContainer = styled(Column)(({ theme }) => ({
  alignSelf: 'center',
  width: '100%',
  backgroundColor: theme.palette.background.default,
  paddingBottom: theme.spacing(3),
  maxHeight: '100%',
}));

const Title = styled(Typography)(({ theme }) => ({
  color: theme.palette.text.primary,
}));

const BasicWrapper = styled(Column)(() => ({
  width: '100%',
  maxWidth: 1920,
  alignSelf: 'center',
}));

const NormalWrapper = styled(BasicWrapper)(({ theme }) => ({
  paddingLeft: theme.spacing(2),
  paddingRight: theme.spacing(2),
  [theme.breakpoints.up('sm')]: {
    paddingLeft: theme.spacing(3),
    paddingRight: theme.spacing(3),
  },
  [theme.breakpoints.up('lg')]: {
    paddingLeft: theme.spacing(3),
    paddingRight: theme.spacing(3),
  },
  [theme.breakpoints.up('xl')]: {
    paddingLeft: theme.spacing(3),
    paddingRight: theme.spacing(3),
  },
  maxHeight: '100%',
  overflow: 'scroll',
  '&::-webkit-scrollbar': {
    display: 'none',
    WebkitAppearance: 'none',
    width: 0,
    height: 0,
  },
}));

const WrapperSimulator = styled(BasicWrapper)(({ theme }) => ({
  paddingLeft: theme.spacing(3),
  paddingRight: theme.spacing(3),

  overflow: 'unset',
  '&::-webkit-scrollbar': {
    display: 'none',
    WebkitAppearance: 'none',
    width: 0,
    height: 0,
  },
}));

const Header = styled('div')(({ theme }) => ({
  position: 'sticky',
  top: 0,
  backgroundColor: theme.palette.background.default,
  zIndex: 1000,
  paddingTop: theme.spacing(3),
  paddingBottom: theme.spacing(3),
}));

const DashboardPageLayout: React.FC<Props> = ({ title, titleSize, children, aside, marginTop, sx }) => {
  const additionalStyle = marginTop ? { marginTop: marginTop, ...sx } : { ...sx };
  const Wrapper = sessionStorage.getItem('simulator')?.toString() === 'true' ? WrapperSimulator : NormalWrapper;

  const content = (
    <Wrapper>
      <>
        {(aside || title) && (
          <Header>
            <Row grow>
              <>
                {title && (
                  <Column>
                    <Title variant="h2" style={titleSize ? { fontSize: titleSize } : {}}>
                      {title}
                    </Title>
                  </Column>
                )}

                {aside && (
                  <Row hAlign="flex-end" grow>
                    <>{aside}</>
                  </Row>
                )}
              </>
            </Row>
          </Header>
        )}
        {children}
      </>
    </Wrapper>
  );

  return (
    <DashboardPageContainer grow style={additionalStyle}>
      {content}
    </DashboardPageContainer>
  );
};

export default DashboardPageLayout;
